import { clinicsFetch } from '../functions/fetchClinics.js'

export const booking = {
  extends: 'Page',
  flow: 'y',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',

  ClinicsData: { fetch: clinicsFetch, display: 'none' },

  NavBar: {},

  BookingContainer: {
    flow: 'y',
    gap: 'B',
    padding: 'C B',
    maxWidth: 'J',
    margin: '0 auto',
    width: '100%',
    '@mobileL': { padding: 'B A' },

    BookingTitle: { tag: 'h1', text: '{{ bookingTitle | polyglot }}', fontSize: 'C', fontWeight: '700', letterSpacing: '-0.02em', textAlign: 'center', color: 'inkText' },
    BookingSubtitle: { text: '{{ selectClinic | polyglot }}', fontSize: 'A', color: 'inkMuted', textAlign: 'center', marginBottom: 'A' },

    BookingModeToggle: {
      flow: 'x',
      gap: 'Y',
      align: 'center center',
      padding: 'Y',
      round: 'Z',
      background: 'inkSurface',
      border: '1px solid inkBorder',
      width: 'fit-content',
      margin: '0 auto',
      marginBottom: 'A',
      show: (el, s) => s.root.activeBookingStep === 1,

      ClinicModeBtn: {
        extends: 'Button',
        text: '{{ bookByClinic | polyglot }}',
        padding: 'Y A',
        round: 'Y',
        fontSize: 'Z',
        fontWeight: '600',
        cursor: 'pointer',
        border: 'none',
        background: (el, s) => (s.root.bookingMode || 'clinic') === 'clinic' ? '#0D1117' : 'transparent',
        color: (el, s) => (s.root.bookingMode || 'clinic') === 'clinic' ? '#FFFFFF' : 'inkMuted',
        onClick: (e, el, s) => s.root.update({ bookingMode: 'clinic', hidePrices: false })
      },
      DoctorModeBtn: {
        extends: 'Button',
        text: '{{ bookByDoctor | polyglot }}',
        padding: 'Y A',
        round: 'Y',
        fontSize: 'Z',
        fontWeight: '600',
        cursor: 'pointer',
        border: 'none',
        background: (el, s) => s.root.bookingMode === 'doctor' ? '#0D1117' : 'transparent',
        color: (el, s) => s.root.bookingMode === 'doctor' ? '#FFFFFF' : 'inkMuted',
        onClick: (e, el, s) => s.root.update({
          bookingMode: 'doctor',
          hidePrices: true,
          clinicDiscounts: {
            'c1': { percent: 15 },
            'c3': { percent: 10 },
            'c5': { percent: 20 }
          }
        })
      }
    },

    StepIndicator: {},

    StepClinic: {
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.activeBookingStep === 1 && (s.root.bookingMode || 'clinic') === 'clinic',
      StepHeading: { tag: 'h2', text: '{{ chooseClinic | polyglot }}', fontSize: 'B', fontWeight: '600', color: 'inkText' },
      SearchRow: {
        flow: 'x',
        gap: 'Z',
        align: 'center center',
        '@mobileL': { flow: 'y' },
        SearchInput: {
          extends: 'Input',
          tag: 'input',
          type: 'text',
          placeholder: 'Search clinics, districts...',
          padding: 'Z A',
          round: 'A',
          background: 'inkSurface',
          color: 'inkText',
          border: '1px solid inkBorder',
          fontSize: 'Z',
          flex: '1',
          onInput: (e, el, s) => s.root.update({ clinicFilter: el.node.value })
        },
        NearMeBtn: {
          extends: 'Button',
          text: '{{ nearMe | polyglot }}',
          background: 'rgba(0,0,0,0.06)',
          color: '#0D1117',
          fontWeight: '600',
          padding: 'Z A',
          round: 'A',
          fontSize: 'Z',
          cursor: 'pointer',
          border: 'none'
        }
      },
      ClinicCount: {
        text: (el, s) => {
          const clinics = s.root.clinics || []
          const q = s.root.clinicFilter
          if (!q) return clinics.length + ' clinics available'
          const n = clinics.filter(c => c.name.toLowerCase().includes(q.toLowerCase()) || c.district.toLowerCase().includes(q.toLowerCase()) || (c.address || '').toLowerCase().includes(q.toLowerCase())).length
          return n + ' clinics found'
        },
        fontSize: 'Y',
        color: 'inkMuted'
      },
      ClinicList: {
        flow: 'y',
        gap: 'Z',
        maxHeight: 'I',
        overflow: 'auto',
        children: (el, s) => s.root.clinics || [],
        childrenAs: 'state',
        childExtends: 'ClinicCard'
      }
    },

    StepDoctor: {
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.activeBookingStep === 1 && s.root.bookingMode === 'doctor',

      StepHeading: { tag: 'h2', text: '{{ chooseDoctor | polyglot }}', fontSize: 'B', fontWeight: '600', color: 'inkText' },

      DoctorSearchInput: {
        extends: 'Input',
        tag: 'input',
        type: 'text',
        placeholder: 'Search doctors by name or specialty...',
        padding: 'Z A',
        round: 'A',
        background: 'inkSurface',
        color: 'inkText',
        border: '1px solid inkBorder',
        fontSize: 'Z',
        width: '100%',
        onInput: (e, el, s) => s.root.update({ doctorFilter: el.node.value })
      },

      DoctorList: {
        flow: 'y',
        gap: 'Z',
        maxHeight: 'I',
        overflow: 'auto',
        marginTop: 'Z',
        children: (el, s) => {
          const doctors = s.root.sampleDoctors || [
            { doctorName: 'Dr. Nino Beridze', specialties: ['Implantology', 'Oral Surgery'], rating: 4.9, reviewCount: 187, clinics: [{ clinicName: 'Denta Plus', clinicId: 'c1', availableTimes: ['09:00', '11:30', '14:00'] }, { clinicName: 'SmileLab', clinicId: 'c3', availableTimes: ['10:00', '15:00'] }] },
            { doctorName: 'Dr. Giorgi Tsiklauri', specialties: ['Orthodontics', 'Cosmetic Dentistry'], rating: 4.8, reviewCount: 124, clinics: [{ clinicName: 'OrthoGeorgia', clinicId: 'c2', availableTimes: ['09:30', '13:00'] }, { clinicName: 'Denta Plus', clinicId: 'c1', availableTimes: ['16:00'] }] },
            { doctorName: 'Dr. Tamta Kvaratskhelia', specialties: ['Pediatric Dentistry', 'Preventive Care'], rating: 4.7, reviewCount: 96, clinics: [{ clinicName: 'KidSmile Clinic', clinicId: 'c4', availableTimes: ['10:00', '12:00', '14:30'] }, { clinicName: 'SmileLab', clinicId: 'c3', availableTimes: ['09:00'] }] },
            { doctorName: 'Dr. Dato Javakhishvili', specialties: ['Endodontics', 'Restorative'], rating: 4.6, reviewCount: 78, clinics: [{ clinicName: 'CavityFree', clinicId: 'c5', availableTimes: ['11:00', '13:30', '16:00'] }] },
            { doctorName: 'Dr. Ana Lomidze', specialties: ['Periodontics', 'Implantology'], rating: 4.9, reviewCount: 203, clinics: [{ clinicName: 'Denta Plus', clinicId: 'c1', availableTimes: ['08:30', '12:00'] }, { clinicName: 'CavityFree', clinicId: 'c5', availableTimes: ['14:00', '17:00'] }] }
          ]
          const q = s.root.doctorFilter
          if (!q) return doctors
          const lower = q.toLowerCase()
          return doctors.filter(d => d.doctorName.toLowerCase().includes(lower) || (d.specialties || []).some(sp => sp.toLowerCase().includes(lower)))
        },
        childrenAs: 'state',
        childExtends: 'DoctorProfileCard'
      }
    },

    StepService: {
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.activeBookingStep === 2,
      StepHeading: { tag: 'h2', text: '{{ selectAService | polyglot }}', fontSize: 'B', fontWeight: '600', color: 'inkText' },
      ServiceList: {
        flow: 'y',
        gap: 'Z',
        children: (el, s) => s.root.services,
        childrenAs: 'state',
        childExtends: 'ServiceOption'
      }
    },

    StepPreCheck: {
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.activeBookingStep === 3,
      StepHeading: { tag: 'h2', text: '{{ preCheckTitle | polyglot }}', fontSize: 'B', fontWeight: '600', color: 'inkText' },
      ServicePreCheck: {}
    },

    StepDate: {
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.activeBookingStep === 4,
      StepHeading: { tag: 'h2', text: '{{ pickADate | polyglot }}', fontSize: 'B', fontWeight: '600', color: 'inkText' },
      DateGrid: {
        flow: 'x',
        flexWrap: 'wrap',
        gap: 'Z',
        children: (el, s) => s.root.dates,
        childrenAs: 'state',
        childExtends: 'DateOption'
      }
    },

    StepTime: {
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.activeBookingStep === 5,
      StepHeading: { tag: 'h2', text: '{{ pickATime | polyglot }}', fontSize: 'B', fontWeight: '600', color: 'inkText' },
      TimeGrid: {
        flow: 'x',
        flexWrap: 'wrap',
        gap: 'Z',
        children: (el, s) => s.root.times,
        childrenAs: 'state',
        childExtends: 'TimeOption'
      }
    },

    StepConfirm: {
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.activeBookingStep === 6,
      padding: 'B',
      round: 'A',
      background: 'inkMid',
      border: '1px solid inkBorder',
      StepHeading: { tag: 'h2', text: '{{ confirmYourBooking | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'inkText' },
      SummaryClinic: {
        flow: 'x', gap: 'Z',
        SumLabel: { text: '{{ clinicLabel | polyglot }}', fontSize: 'Z', color: 'inkMuted', fontWeight: '600' },
        SumValue: { text: (el, s) => s.root.selectedClinic || '—', fontSize: 'Z', color: 'inkText' }
      },
      SummaryService: {
        flow: 'x', gap: 'Z',
        SumLabel: { text: '{{ serviceLabel | polyglot }}', fontSize: 'Z', color: 'inkMuted', fontWeight: '600' },
        SumValue: { text: (el, s) => s.root.selectedService || '—', fontSize: 'Z', color: 'inkText' }
      },
      SummaryDate: {
        flow: 'x', gap: 'Z',
        SumLabel: { text: '{{ dateLabel | polyglot }}', fontSize: 'Z', color: 'inkMuted', fontWeight: '600' },
        SumValue: { text: (el, s) => s.root.selectedDate || '—', fontSize: 'Z', color: 'inkText' }
      },
      SummaryTime: {
        flow: 'x', gap: 'Z',
        SumLabel: { text: '{{ timeLabel | polyglot }}', fontSize: 'Z', color: 'inkMuted', fontWeight: '600' },
        SumValue: { text: (el, s) => s.root.selectedTime || '—', fontSize: 'Z', color: 'inkText' }
      },
      ConfirmBtn: {
        extends: 'Button',
        text: '{{ confirmBooking | polyglot }}',
        marginTop: 'A',
        background: '#0D1117',
        color: '#FFFFFF',
        fontWeight: '600',
        padding: 'Z B',
        round: 'B',
        fontSize: 'Z2',
        cursor: 'pointer',
        border: 'none',
        width: '100%',
        textAlign: 'center'
      }
    },

    BookingNav: {
      flow: 'x',
      gap: 'A',
      align: 'center space-between',
      marginTop: 'B',
      BackBtn: {
        extends: 'Button',
        text: '{{ back | polyglot }}',
        show: (el, s) => s.root.activeBookingStep > 1,
        background: 'inkSurface',
        color: 'inkText',
        fontWeight: '600',
        padding: 'Z B',
        round: 'B',
        fontSize: 'Z',
        cursor: 'pointer',
        border: '1px solid inkBorder',
        onClick: (e, el, s) => s.root.update({ activeBookingStep: s.root.activeBookingStep - 1 })
      },
      NextBtn: {
        extends: 'Button',
        text: '{{ next | polyglot }}',
        show: (el, s) => s.root.activeBookingStep < 6,
        background: '#0D1117',
        color: '#FFFFFF',
        fontWeight: '600',
        padding: 'Z B',
        round: 'B',
        fontSize: 'Z',
        cursor: 'pointer',
        border: 'none',
        marginLeft: 'auto',
        onClick: (e, el, s) => s.root.update({ activeBookingStep: s.root.activeBookingStep + 1 })
      }
    }
  }
}
